import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import { createContext, use } from "react";
import type { FieldConfiguration } from "../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  AccountingBook,
  ConditionField,
  DimensionDescriptor,
  DimensionsStructure,
  ReportField,
  ReportType,
  SortField,
} from "../../../../../api/types/svTypes.ts";

export interface BiCommonDataContextType {
  reportType?: ReportType;
  dimensionsStructure?: DimensionsStructure;
  dimensions: DimensionDescriptor[];
  books: AccountingBook[];
  isMultiBook: boolean;
  editMode: boolean;
  isApiReport?: boolean;
  conditions: ConditionField[];
  reportId: string | undefined;
  refreshToken: string | undefined;
  dimensionNames: string[];
  measureNames: string[];
  dataSetId: string;
  onFieldWithCustomConditionUpdate?: (field: ReportField, change: Partial<FieldConfiguration>) => void;
  onConditionUpdate: (field: ConditionField, changes: Partial<ConditionField>) => void;
  onRefreshGrid: () => void;
  onSortingUpdate?: (newSorting: SortField[]) => void;
}

export const BiCommonDataContext = createContext<BiCommonDataContextType | undefined>(undefined);

export const useBiCommonDataContext = () => {
  const context = use(BiCommonDataContext);
  return defined(context);
};
